/**
 * Edit rules for work-item time logs (Work Items → Work log tab).
 * Admins may edit any row; others may edit only logs they created.
 */

export function resolveLoggedByUserId(item) {
  if (!item || typeof item !== "object") return null;

  const by = item.loggedBy;
  if (by && typeof by === "object") {
    const id = by.id ?? by.userId ?? by.user_id;
    if (id != null && String(id).trim() !== "") return String(id).trim();
  }

  const flatId = item.loggedById ?? item.logged_by_id ?? item.userId ?? item.user_id;
  if (flatId != null && String(flatId).trim() !== "") return String(flatId).trim();

  return null;
}

export function isOwnWorkItemTimeLog(item, currentUserId) {
  if (!currentUserId) return false;
  const loggedByUserId = resolveLoggedByUserId(item);
  if (!loggedByUserId) return false;
  return loggedByUserId === String(currentUserId).trim();
}

/**
 * @param {{
 *   canEditTimeEntry?: boolean;
 *   isAdmin?: boolean;
 *   currentUserId?: string | null;
 *   item?: object | null;
 * }} options
 */
export function canEditWorkItemTimeLog({
  canEditTimeEntry = false,
  isAdmin = false,
  currentUserId = null,
  item = null,
} = {}) {
  if (!canEditTimeEntry) return false;
  if (isAdmin) return true;
  return isOwnWorkItemTimeLog(item, currentUserId);
}
